export const OPEN_COOKIES_BANNER = (state, data) => {
  state.forceOpenCookiesMainBanner = data;
};

export const ENABLE_COOKIE = (state) => {
  state.isCookieEnabled = true;
};
